// export default {
let observer__;
let elArr_ ;
let root_;
export const observeView = {
  start: (isOnce) => {
    elArr_ = document.querySelectorAll("[el-move]") || null;
    root_ = document.getElementById("#app")
    elArr_.forEach(el => el.classList.remove('aos-animate'));
    // 监听元素
    const options = {
      root: root_, // 指定根(root)元素，未指定或 null 则默认为浏览器视窗
      // threshold: threshold || 1 // 监听目标与边界盒交叉区域的比例值 0-1,
      threshold: [0, 0.25, 0.5, 0.75, 1],
      thresholdOnce: true,
    }
    observer__ = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // console.log(entry, '~~~~~~~进入可视区域')
          // 执行回调方法
          // entry.target.classList.remove('aos-animate')
          // setTimeout(() => {
          entry.target.classList.add('aos-animate')
          // }, 50)
          if (isOnce) {
            observer__.unobserve(entry.target)
          }
        } else {
          // console.log(entries, "~~~~~~~~~~~~~离开可视区域");
          setTimeout(() => {
            entry.target.classList.remove('aos-animate')
            // 停止监听
            // observer__.unobserve(entry.target)
          }, 1000)

        }
      })
    }, options)

    // 遍历每个元素并调用 observe 方法
    elArr_.forEach(el => observer__.observe(el));
  },
  disconnect: () => {
    observer__.disconnect()
  },
  unobserve: (el) => {
    if (el) {
      observer__.unobserve(el)
    } else { 
      // 遍历每个元素并调用 unobserve 方法
      elArr_.forEach(el => observer__.unobserve(el));
    }

   
  }
}


// WEBPACK FOOTER //
// ./src/utils/observeView.js